import WebSocketWorker from "@/service/worker/wsWorker.worker.js";
import store from "@/store";

class BackendSyncWebSocketService {
	constructor(clientId) {

		const { websocketUrl, websocketPort } = store.state.config;

		this.url = websocketUrl;
		this.port = websocketPort;
		this.clientId = clientId;

		this.worker = new WebSocketWorker();

		this.listeners = [];

		this.worker.onmessage = this.handleWorkerMessage.bind(this);

		// Listen for online/offline events to trigger immediate reconnection
		this.handleOnline = this.handleOnline.bind(this);
		this.handleOffline = this.handleOffline.bind(this);
		window.addEventListener('online', this.handleOnline);
		window.addEventListener('offline', this.handleOffline);
	}

	handleOnline() {
		console.log('[BackendSyncWebSocketService] Device came online - triggering force reconnect');
		this.worker.postMessage({ type: 'forceReconnect' });
	}

	handleOffline() {
		console.log('[BackendSyncWebSocketService] Device went offline');
		// The worker will handle socket closure naturally
	}

	connect() {

		const payload = {
			url: this.url,
			port: this.port,
			clientId: this.clientId,
		};

		console.log("Nos queremos conectar al wsworker con payload:",payload);
		this.worker.postMessage({ type: 'connect', payload });
	}

	disconnect() {
		this.worker.postMessage({ type: 'disconnect' });
		// Clean up event listeners
		window.removeEventListener('online', this.handleOnline);
		window.removeEventListener('offline', this.handleOffline);
	}

	sendMessage(message) {
		this.worker.postMessage({ type: 'send', payload: { message } });
	}

	handleWorkerMessage(event) {
		const { type, data, error } = event.data;

		switch (type) {
			case 'connected':
			case 'connecting':
			case 'disconnected':
			case 'error':
				// Pass these events on to the listeners
				this.listeners.forEach((listener) => {
					listener(type, error || data);
				});
				break;

			case 'message':
				// forward the entire data object to the listeners
				this.listeners.forEach((listener) => {
					listener('message', data);
				});
				break;

			default:
				// Unknown or unexpected message from worker
				console.warn('Unknown message from WebSocket worker:', event.data);
				break;
		}
	}

	addMessageListener(listener) {
		this.listeners.push(listener);
	}

	removeMessageListener(listener) {
		this.listeners = this.listeners.filter((l) => l !== listener);
	}
}

export default BackendSyncWebSocketService;
